// // Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "./theme/set_jquery"
import "@hotwired/turbo-rails"
import "./initializers"
import "./controllers"
import "./channels"
import "./scroll_restoration"


// import jquery from 'jquery'
// globalThis.jQuery = jquery
// globalThis.$ = jquery
import * as bootstrap from 'bootstrap'
globalThis.bootstrap = bootstrap


import { default as Swal } from 'sweetalert2'
globalThis.Swal = Swal


import './payments/runtime-module'
import "./theme/custom"
import "./theme/jquery.caret.min"
import "./theme/multilevel_dropdown"
import "./theme/password"

let prelineLoaded = false

function hasPrelineComponent() {
  return document.querySelector(
    "[data-hs-form-search]"
  )
}

async function initPrelinePasswordToggle() {
  if (!hasPrelineComponent()) return

  if (!prelineLoaded) {
    await import("preline")
    prelineLoaded = true
  }

  globalThis.HSStaticMethods?.autoInit()
}

document.addEventListener("turbo:load", initPrelinePasswordToggle)
document.addEventListener("turbo:frame-load", initPrelinePasswordToggle)
